// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__f1YfE","contactContainer":"NotFound_contactContainer__VPbK3","contact":"NotFound_contact__zpFdd"};